import { render, staticRenderFns } from "./LafiaStudio.vue?vue&type=template&id=e43863bc&scoped=true"
import script from "./LafiaStudio.vue?vue&type=script&lang=js"
export * from "./LafiaStudio.vue?vue&type=script&lang=js"
import style0 from "./LafiaStudio.vue?vue&type=style&index=0&id=e43863bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e43863bc",
  null
  
)

export default component.exports